import { declarationKeys } from './';

export const deletedDeclarationKeys = {
  ...declarationKeys,
  date: {
    from: 'dateFrom',
    to: 'dateTo',
  },
};
